import _toConsumableArray from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\AMP\\gw-amp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { __rest } from "tslib";
import { duplicate, hash as _hash } from '../../util';
import { DataFlowNode } from './dataflow';
/**
 * A class for quantile transform nodes
 */
export var QuantileTransformNode = /*#__PURE__*/function (_DataFlowNode) {
  function QuantileTransformNode(parent, transform) {
    var _this;
    _classCallCheck(this, QuantileTransformNode);
    var _a, _b, _c;
    _this = _callSuper(this, QuantileTransformNode, [parent]);
    _this.transform = transform;
    _this.transform = duplicate(transform); // duplicate to prevent side effects
    var specifiedAs = (_a = _this.transform.as) !== null && _a !== void 0 ? _a : [undefined, undefined];
    _this.transform.as = [(_b = specifiedAs[0]) !== null && _b !== void 0 ? _b : 'prob', (_c = specifiedAs[1]) !== null && _c !== void 0 ? _c : 'value'];
    return _this;
  }
  _inherits(QuantileTransformNode, _DataFlowNode);
  return _createClass(QuantileTransformNode, [{
    key: "clone",
    value: function clone() {
      return new QuantileTransformNode(null, duplicate(this.transform));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      var _a;
      return new Set([this.transform.quantile].concat(_toConsumableArray((_a = this.transform.groupby) !== null && _a !== void 0 ? _a : [])));
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(this.transform.as);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "QuantileTransform ".concat(_hash(this.transform));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var _a = this.transform,
        quantile = _a.quantile,
        rest = __rest(_a, ["quantile"]);
      var result = Object.assign({
        type: 'quantile',
        field: quantile
      }, rest);
      return result;
    }
  }]);
}(DataFlowNode);